<template>
  <nav class="navbar navbar-expand header px-i">
    <ul class="navbar-nav header-wrapper">
      <li class="nav-item header-toggle">
        <a class="nav-link header-toggle-icon" href="#" @click="toggleSidebar($event)">
          <i class="demo-icon icon-bars" />
        </a>
      </li>
      <li class="nav-item header-logo">
        <a class="header-logo-link"
           href="#">
          <img :src="tenantUrl" class="header-logo-link-image">
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "Navigation",

  props: {
    tenantUrl: { type: String }
  },

  methods: {
    toggleSidebar: function (e) {
      e.preventDefault();
      this.$emit("toggleSidebar");
    }
  }
};
</script>
